import React, { Component } from "react";
import { NavLink } from "react-router-dom"

import MenuStyles from "components/menu/MenuFoot.module.scss";

export class MenuFootGp extends Component {
  scrollToTopOfMain = () => {
    let el = document.getElementById("gb-contents");
    el.scrollTop = 0;
  };

  render () {
    return (
      <div className={MenuStyles["menu-foot"]}>         
        <span>
          <strong>Dúvidas?</strong> Envie pra gente
          <a target={"_blank"}  href={`${process.env.REACT_APP_GB_APP_ROOT}/glampartner/duvidas`}>AQUI!</a>
        </span>
        <div className={MenuStyles["menu-foot__controlls"]}>
          <NavLink to={"/glampartner/faq"} 
                  onClick={this.scrollToTopOfMain}
                  className={MenuStyles["menu-foot__link"]}
                  activeClassName={MenuStyles["active"]}>
            FAQ
          </NavLink>
          <NavLink to={"/glampartner/termos"} 
                  onClick={this.scrollToTopOfMain}
                  className={MenuStyles["menu-foot__link"]}
                  activeClassName={MenuStyles["active"]}>
            Termos
          </NavLink>
          <NavLink to={"/privacidade"} 
                  onClick={this.scrollToTopOfMain}
                  className={MenuStyles["menu-foot__link"]}
                  activeClassName={MenuStyles["active"]}>
            Privacidade
          </NavLink>
          
        </div>
      </div>
    );
  }
}
